import { reactive, Ref } from "vue";
import useVuelidate, { Validation, ValidationArgs } from "@vuelidate/core";
import {
  required,
  minLength,
  maxLength,
  email,
  helpers,
} from "@vuelidate/validators";
import { useRoute } from "vue-router";

export interface Step1FormInterface {
  lastname: string;
  broker: string;
  email: string;
  files: string[];
}

export interface FormInterface {
  v$: Ref<Validation<ValidationArgs>>;
  fields: Step1FormInterface;
}

const form = (): FormInterface => {
  const route = useRoute();

  const state = reactive<Step1FormInterface>({
    lastname: route.query?.name?.toString() || "",
    broker: route.query?.broker?.toString() || "",
    email: route.query?.email?.toString() || "",
    files: [],
  });

  const rules: ValidationArgs = {
    lastname: {
      required: helpers.withMessage("required", required),
      minLength: helpers.withMessage("min_length", minLength(2)),
      maxLength: helpers.withMessage("max_length", maxLength(50)),
      /** Regex: Uniquement lettre, espace et tiret */
      alpha: helpers.withMessage("alpha", helpers.regex(/^[a-zA-ZÀ-ž\-\s]+$/i)),
    },
    broker: {
      minLength: helpers.withMessage("min_length", minLength(2)),
      maxLength: helpers.withMessage("max_length", maxLength(50)),
      /** Regex: Uniquement lettre, numero, espace et tiret */
      alphaNumeric: helpers.withMessage("alphanumeric", helpers.regex(/^[a-zA-ZÀ-ž0-9\-.\s]+$/i)),
    },
    email: {
      required: helpers.withMessage("required", required),
      email: helpers.withMessage("email", email),
    },
    files: {
      required: helpers.withMessage("required", required),
    },
  };

  const v$ = useVuelidate(rules, state);

  return { v$, fields: state };
};

export default form;
